
import React from 'react';
import PersonalInfoSection from './PersonalInfoSection';
import ContentSection from './ContentSection';
import FormActions from './FormActions';
import { useProductionForm } from '@/hooks/production/useProductionForm';
import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const ProductionForm: React.FC = () => {
  const {
    loading,
    answer,
    setAnswer,
    name,
    setName,
    title,
    setTitle,
    company,
    setCompany,
    context,
    setContext,
    contextUrl,
    setContextUrl,
    contextImageUrl,
    setContextImageUrl,
    contextImageCaption,
    setContextImageCaption,
    question,
    setQuestion,
    photoUrl,
    setPhotoUrl,
    photographerCredit,
    setPhotographerCredit,
    tags,
    setTags,
    isSponsored,
    setIsSponsored,
    sponsorCompany,
    setSponsorCompany,
    handleSubmit,
    VALID_TAGS
  } = useProductionForm();

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <PersonalInfoSection 
        name={name}
        setName={setName}
        title={title}
        setTitle={setTitle}
        company={company}
        setCompany={setCompany}
        photoUrl={photoUrl}
        setPhotoUrl={setPhotoUrl}
        photographerCredit={photographerCredit}
        setPhotographerCredit={setPhotographerCredit}
      />
      
      <ContentSection 
        context={context}
        setContext={setContext}
        contextUrl={contextUrl}
        setContextUrl={setContextUrl}
        contextImageUrl={contextImageUrl}
        setContextImageUrl={setContextImageUrl}
        contextImageCaption={contextImageCaption}
        setContextImageCaption={setContextImageCaption}
        question={question}
        setQuestion={setQuestion}
        answer={answer}
        setAnswer={setAnswer}
        tags={tags}
        setTags={setTags}
        validTags={VALID_TAGS}
      />

      {/* Sponsored content section */}
      <div className="border rounded-md p-4">
        <h3 className="text-lg font-semibold mb-4">Annonsørinnhold</h3>
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Checkbox
              id="is-sponsored"
              checked={isSponsored}
              onCheckedChange={(checked) => setIsSponsored(checked === true)}
            />
            <Label htmlFor="is-sponsored" className="cursor-pointer">
              Annonsørinnhold (Betalt Brief)
            </Label>
          </div>
          {isSponsored && (
            <div className="space-y-2">
              <Label htmlFor="sponsor-company">Annonsørens firmanavn</Label>
              <Input
                id="sponsor-company"
                placeholder="F.eks. Xpeng, DNB, Equinor..."
                value={sponsorCompany}
                onChange={(e) => setSponsorCompany(e.target.value)}
              />
            </div>
          )}
        </div>
      </div>
      
      <FormActions loading={loading} />
    </form>
  );
};

export default ProductionForm;
